import { render } from "./IconStarHalf.vue?vue&type=template&id=0e569a58"
import script from "./IconStarHalf.vue?vue&type=script&lang=js"
export * from "./IconStarHalf.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__